import React from 'react';
 // Import CSS specific to Footer

const Footer = () => {
    return (
        <footer className="main-footer">
                    <strong>
					© 2024 All rights reserved VDC</strong> 
        </footer>
    );
};

export default Footer;